// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TabletFilledSvg from "@fishx/icons-svg/es/asn/TabletFilled";
import FishxIcon from '../components/FishxIcon';

var TabletFilled = function TabletFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TabletFilledSvg
  }));
};

TabletFilled.displayName = 'TabletFilled';
export default React.forwardRef(TabletFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TabletFilled.js
// module id = 4223
// module chunks = 0